import React from 'react';
import { useNavigate } from 'react-router-dom'


function PlayListSong(props) {
    const navigate = useNavigate();
    return (
        <div className="flex flex-row justify-between bg-gray-100 p-4 rounded-lg w-full" onClick={() => navigate(`/song/${props.id}`)}>
            <div>{props.name}</div>
            <div>{props.time}</div>
        </div>
    );
}

export default PlayListSong;